import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

/**
 * Figma (node 18665:780):
 * bg-muted (#f5f5f5), h-5 (20px), min-w-[20px], px-1 (4px), rounded-sm (6px),
 * text-xs (12px), font-medium (500), leading-4 (16px), text-muted-foreground (#737373)
 */
export interface IntuiKbdProps {
  children: ReactNode
  className?: string
}

function IntuiKbd({ children, className }: IntuiKbdProps) {
  return (
    <kbd className={cn(
      'pointer-events-none inline-flex h-5 min-w-[20px] select-none items-center justify-center gap-1 rounded-sm bg-muted px-1 text-xs font-medium leading-4 text-muted-foreground whitespace-nowrap',
      className
    )}>
      {children}
    </kbd>
  )
}

/** Renders a key combination like ["Cmd", "K"] with + separators */
export interface IntuiKbdGroupProps {
  keys: string[]
  className?: string
}

function IntuiKbdGroup({ keys, className }: IntuiKbdGroupProps) {
  return (
    <span className={cn('inline-flex items-center gap-1', className)}>
      {keys.map((key, i) => (
        <IntuiKbd key={i}>{key}</IntuiKbd>
      ))}
    </span>
  )
}

export { IntuiKbd, IntuiKbdGroup }
